import "./BaseLayout.css";
import { Outlet } from "react-router-dom";
import { Center, Box } from "@chakra-ui/react";
import PSLogo from "./../../assets/ps-logo-NEW.svg";
const BaseLayout = () => {
  return (
    <Center className="Layout-container">
      <img src={PSLogo} className="Layout-ps-logo" alt="ps logo" />
      <Box
        border="2px"
        backgroundColor="#fff"
        borderColor="gray.200"
        borderRadius="lg"
        width="440px"
        height="500px"
        p={10}
      >
        <Outlet />
      </Box>
    </Center>
  );
};

export default BaseLayout;
